// src/pages/form_facturacion.jsx
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles.css';

const FomularioFactura = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const idUrl = searchParams.get('id'); // opcional si lo pasas por ?id=...

    const [enviando, setEnviando] = useState(false);
    const [errorEnvio, setErrorEnvio] = useState(null);

    const opcionesRegimenes = [
        { "value": "", "label": "Selecciona un régimen" },
        { "value": "601", "label": "Régimen General de Ley Personas Morales" },
        { "value": "602", "label": "Régimen Simplificado de Ley Personas Morales" },
        { "value": "603", "label": "Personas Morales con Fines no Lucrativos" },
        { "value": "604", "label": "Régimen de Pequeños Contribuyentes" },
        { "value": "605", "label": "Régimen de Sueldos y Salarios e Ingresos Asimilados a Salarios" },
        { "value": "606", "label": "Régimen de Arrendamiento" },
        { "value": "607", "label": "Régimen de Enajenación o Adquisición de Bienes" },
        { "value": "608", "label": "Régimen de los Demás Ingresos" },
        { "value": "609", "label": "Régimen de Consolidación" },
        { "value": "610", "label": "Régimen Residentes en el Extranjero sin Establecimiento Permanente en México" },
        { "value": "611", "label": "Régimen de Ingresos por Dividendos (Socios y Accionistas)" },
        { "value": "612", "label": "Régimen de las Personas Físicas con Actividades Empresariales y Profesionales" },
        { "value": "613", "label": "Régimen Intermedio de las Personas Físicas con Actividades Empresariales" },
        { "value": "614", "label": "Régimen de los Ingresos por Intereses" },
        { "value": "615", "label": "Régimen de los Ingresos por Obtención de Premios" },
        { "value": "616", "label": "Sin Obligaciones Fiscales" },
        { "value": "617", "label": "Pemex" },
        { "value": "618", "label": "Régimen Simplificado de Ley Personas Físicas" },
        { "value": "619", "label": "Ingresos por la Obtención de Préstamos" },
        { "value": "620", "label": "Sociedades Cooperativas de Producción que Optan por Diferir sus Ingresos" },
        { "value": "621", "label": "Régimen de Incorporación Fiscal" },
        { "value": "622", "label": "Régimen de Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras PM" },
        { "value": "623", "label": "Régimen de Opcional para Grupos de Sociedades" },
        { "value": "624", "label": "Régimen de los Coordinados" },
        { "value": "625", "label": "Régimen de las Actividades Empresariales con Ingresos a través de Plataformas Tecnológicas" },
        { "value": "626", "label": "Régimen Simplificado de Confianza" }
      ];

    const opciones_uso_cfdi = [
        { "value": "", "label": "Selecciona un uso de cfdi" },
        {
          "value": "G01 - Adquisición de mercancías",
          "label": "G01 - Adquisición de mercancías"
        },
        {
          "value": "G02 - Devoluciones, descuentos o bonificaciones",
          "label": "G02 - Devoluciones, descuentos o bonificaciones"
        },
        {
          "value": "G03 - Gastos en general",
          "label": "G03 - Gastos en general"
        },
        {
          "value": "I01 - Construcciones",
          "label": "I01 - Construcciones"
        },
        {
          "value": "I02 - Mobiliario y equipo de oficina para inversiones",
          "label": "I02 - Mobiliario y equipo de oficina para inversiones"
        },
        {
          "value": "I03 - Equipo de transporte",
          "label": "I03 - Equipo de transporte"
        },
        {
          "value": "I04 - Equipo de cómputo y accesorios",
          "label": "I04 - Equipo de cómputo y accesorios"
        },
        {
          "value": "I05 - Dados, troqueles, moldes, matrices y herramental",
          "label": "I05 - Dados, troqueles, moldes, matrices y herramental"
        },
        {
          "value": "I06 - Comunicaciones telefónicas",
          "label": "I06 - Comunicaciones telefónicas"
        },
        {
          "value": "I07 - Comunicaciones satelitales",
          "label": "I07 - Comunicaciones satelitales"
        },
        {
          "value": "I08 - Otra máquina y equipo",
          "label": "I08 - Otra máquina y equipo"
        },
        {
          "value": "D01 - Honorarios médicos, dentales y hospitalarios",
          "label": "D01 - Honorarios médicos, dentales y hospitalarios"
        },
        {
          "value": "D02 - Gastos médicos por incapacidad o discapacidad",
          "label": "D02 - Gastos médicos por incapacidad o discapacidad"
        },
        {
          "value": "D03 - Gastos funerales",
          "label": "D03 - Gastos funerales"
        },
        {
          "value": "D04 - Donativos",
          "label": "D04 - Donativos"
        },
        {
          "value": "D05 - Intereses reales pagados por créditos hipotecarios",
          "label": "D05 - Intereses reales pagados por créditos hipotecarios"
        },
        {
          "value": "D06 - Aportaciones voluntarias al SAR",
          "label": "D06 - Aportaciones voluntarias al SAR"
        },
        {
          "value": "D07 - Primas de seguros de gastos médicos",
          "label": "D07 - Primas de seguros de gastos médicos"
        },
        {
          "value": "D08 - Gastos de transportación escolar obligatoria",
          "label": "D08 - Gastos de transportación escolar obligatoria"
        },
        {
          "value": "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
          "label": "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones"
        },
        {
          "value": "D10 - Pagos por servicios educativos (colegiaturas)",
          "label": "D10 - Pagos por servicios educativos (colegiaturas)"
        },
        {
          "value": "S01 - Sin efectos fiscales",
          "label": "S01 - Sin efectos fiscales"
        },
        {
          "value": "CP01 - Pagos",
          "label": "CP01 - Pagos"
        },
        {
          "value": "CN01 - Nomina",
          "label": "CN01 - Nomina"
        }
      ];

    const [factura, setFactura] = useState({
        mismosDatos: false,
        nombre: '',
        rfc: '',
        regimen_fiscal: '',
        uso_cfdi: '',
        calle: '',
        municipio: '',
        colonia: '',
        codigo_postal: '',
        num_ext: '',
        num_int: ''
    });

    const [errores, setErrores] = useState({});


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        const valorValidado = name === 'rfc' ? value.toUpperCase() : value;

        setErrores(prevErrores => {
            const nuevosErrores = { ...prevErrores };

            // 1. Validar la longitud del RFC y establecer el error si no cumple
            if (name === 'rfc') {
                const rfcLength = valorValidado.length;

                // La condición clave: El error solo se muestra si hay un valor Y la longitud no es 12 o 13.
                if (rfcLength > 0 && rfcLength !== 12 && rfcLength !== 13) {
                    nuevosErrores.rfc = 'El RFC debe tener 12 o 13 caracteres.';
                } else {
                    // Si la longitud es correcta o el campo está vacío, eliminamos el error de RFC.
                    delete nuevosErrores.rfc;
                }
            } else {
                // Para otros campos, simplemente borramos su error al escribir
                delete nuevosErrores[name];
            }

            return nuevosErrores;
        });


        setFactura(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validarFormulario = () => {
        let erroresTemp = {};

        const camposObligatorios = [
            'nombre', 'rfc', 'regimen_fiscal', 'codigo_postal', 'uso_cfdi'
        ];

        camposObligatorios.forEach(campo => {
            if (!factura[campo].trim()) {
                console.log(campo)
                console.log(factura[campo])
                erroresTemp[campo] = 'Este campo es obligatorio';
            }

        });

        // Validación específica para la longitud del RFC
        const rfcValue = factura.rfc.trim();
        const rfcLength = rfcValue.length;

        // Solo validamos la longitud si el campo no está vacío
        if (rfcValue && rfcLength !== 12 && rfcLength !== 13) {
            erroresTemp.rfc = 'El RFC debe tener 12 o 13 caracteres.';
        }

        setErrores(erroresTemp);
        return Object.keys(erroresTemp).length === 0;

    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validarFormulario()) {
            setEnviando(true);
            setErrorEnvio(null);

            try {
                // Normaliza RFC en mayúsculas (común en facturación MX)
                console.log(factura)
                const payload = { id: idUrl, datos: { ...factura, rfc: factura.rfc?.toUpperCase?.() || factura.rfc } };


                const resp = await fetch('https://www.datoscloudfunctions-prd.rotoplas.com/facturacion', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                if (!resp.ok) {
                    const txt = await resp.text().catch(() => '');
                    throw new Error(`HTTP ${resp.status} ${txt}`);


                }
                const data = await resp.json().catch(() => ({}));
                navigate('/datos_fact_ok', { replace: true, state: { apiData: data } });
                return; // 👈 muy importante para no seguir ejecutando

                // Si todo OK y no hay URL para redirigir, manda a pantalla de confirmación

            } catch (err) {
                setErrorEnvio(err.message);
            } finally {
                setEnviando(false);
            }

        } else {
            //console.log('Errores en el form ')
        }



    };

    return (
        <div className="contenedor-formulario">
            <form onSubmit={handleSubmit} className="formulario-rotoplas">
                <h2 className="titulo-seccion">Ingresa tus datos de facturación</h2>
                <p style={{ color: '#001433' }}>
                    * Asegúrate de que la información coincida con tu <strong>Constancia de Situación Fiscal vigente</strong>;
                    de no ser así, la factura se emitirá al público en general.
                </p>
                <p style={{ color: '#EB8500', fontWeight: 'bold' }}>
                    * Una vez emitida la factura ya no se podrán realizar cambios.
                </p>

                {/*<div className="mismos-datos">
          <input
            type="checkbox"
            id="mismosDatos"
            name="mismosDatos"
            checked={factura.mismosDatos}
            onChange={handleChange}
          />
          <label htmlFor="mismosDatos">
            Mantener el nombre y dirección tal como aparecen en la compra
          </label>
        </div>*/}

                <div className="grupo-input">
                    <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={factura.nombre}
                        onChange={handleChange}
                        placeholder="Nombre o Razón Social"
                    />
                    {errores.nombre && <p className="mensaje-error">{errores.nombre}</p>}
                </div>

                <div className="grupo-input">
                    <input
                        type="text"
                        id="rfc"
                        name="rfc"
                        value={factura.rfc}
                        onChange={handleChange}
                        placeholder="RFC"
                        autocapitalize="characters"
                        maxLength="13"
                    />
                    {errores.rfc && <p className="mensaje-error">{errores.rfc}</p>}
                </div>

                <div className="grupo-input">
                    <select
                        type="text"
                        id="regimen_fiscal"
                        name="regimen_fiscal"
                        value={factura.regimen_fiscal}
                        onChange={handleChange}
                        placeholder="Régimen Fiscal"
                    >
                        {opcionesRegimenes.map((opcion) => (
                            <option key={opcion.value} value={opcion.value}>
                                {opcion.label}
                            </option>
                        ))}
                    </select>
                    {errores.regimen_fiscal && <p className="mensaje-error">{errores.regimen_fiscal}</p>}
                </div>

                <div className="grupo-input">
                    <select
                        type="text"
                        id="uso_cfdi"
                        name="uso_cfdi"
                        value={factura.uso_cfdi}
                        onChange={handleChange}
                        placeholder="Uso de cfdi"  
                    >
                        {opciones_uso_cfdi.map((opcion) => (
                            <option key={opcion.value} value={opcion.value}>
                                {opcion.label}
                            </option>
                        ))}
                    </select>
                    {errores.uso_cfdi && <p className="mensaje-error">{errores.uso_cfdi}</p>}
                </div>

                <div className="grupo-input">
                    <input
                        type="text"
                        placeholder="Calle"
                        name="calle"
                        value={factura.calle}
                        onChange={handleChange}

                    />
                    {errores.calle && <p className="mensaje-error">{errores.calle}</p>}
                </div>

                <div className="grupo-input-row">
                    <input
                        type="text"
                        placeholder="Número Ext."
                        name="num_ext"
                        value={factura.num_ext}
                        onChange={handleChange}
                        className="input-half"

                    />
                    <input
                        type="text"
                        placeholder="Núm. Int"
                        name="num_int"
                        value={factura.num_int}
                        onChange={handleChange}
                        className="input-half"
                    />
                </div>

                <div className="grupo-input">
                    <input
                        type="text"
                        placeholder="Municipio/Delegación"
                        name="municipio"
                        value={factura.municipio}
                        onChange={handleChange}
                    />
                    {errores.municipio && <p className="mensaje-error">{errores.municipio}</p>}
                </div>

                <div className="grupo-input">
                    <input
                        type="text"
                        placeholder="Colonia"
                        name="colonia"
                        value={factura.colonia}
                        onChange={handleChange}

                    />
                    {errores.colonia && <p className="mensaje-error">{errores.colonia}</p>}
                </div>

                <div className="grupo-input">
                    <input
                        type="tel"
                        placeholder="Código Postal"
                        name="codigo_postal"
                        value={factura.codigo_postal}
                        onChange={handleChange}
                        maxLength="5"
                    />
                    {errores.codigo_postal && <p className="mensaje-error">{errores.codigo_postal}</p>}
                </div>


                {errores.num_ext && <p className="mensaje-error">{errores.num_ext}</p>}

                {errorEnvio && (
                    <p style={{ color: 'crimson', marginTop: 12 }}>
                        {errorEnvio}
                    </p>
                )}

                <button type="submit" className="boton-next" disabled={enviando}>
                    {enviando ? 'Enviando…' : 'Confirmar datos'}
                </button>

            </form>
        </div>
    );
};

export default FomularioFactura;
